import React, { FC, useEffect } from 'react';
import { ReviewUnderwriting } from './ReviewUnderwriting';
import { TechnicalReview } from './TechnicalReview';
import { ReviewFooter } from './ReviewFooter';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { STATUSES } from '../../views/login/Login';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ApplicationDetailsNotification } from './ApplicationDetailsNotification';


export const ApplicationDetailsReview: FC = () => {
  const { merchantState: { applicationData }} = useMerchants();
  const { applicationId } = useParams<{ applicationId: string }>();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (applicationId && pathname === `/accounts/applications/${applicationId}`) {
      navigate(`/accounts/applications/${applicationId}/review`);
    }
  }, []);

  return (
    <>
      <ApplicationDetailsNotification />

      <ReviewUnderwriting />
      <TechnicalReview />
      {
        applicationData?.statusName !== STATUSES.CANCELLED
        && applicationData?.statusName !== STATUSES.DECLINED
        && <ReviewFooter />
      }
    </>
  );
};